// extracted by mini-css-extract-plugin
export var footer = "index-module--footer--8aefb";
export var loading = "index-module--loading--c1ac4";
export var loadingVisible = "index-module--loadingVisible--e3fb2";